import NavScrollSpy from 'nav-scroll-spy';
import ScrollToElement from 'scroll-window-to-element';

const selector = 'nav a.tab-spy';
const container = '.scroll-links_wrapper';

const quarterWindowHeight = window.innerHeight / 4 + 50;

const spy = new NavScrollSpy({
  selector,
  offset: quarterWindowHeight,
});
spy.init();

const scroller = new ScrollToElement({
  anchors: selector,
  offset: -140,
});
scroller.init();

document.addEventListener("DOMContentLoaded", function() { 
  $(window).scroll(() => {
    // const scrollPoint = $(container).find('li:first').offset().left
    // - $(container).find('li.active').offset().left;

    const activeElement = $(`${container}`).find('li.active:first');
    const firstElement = $(`${container}`).find('li:first');

    const scrollPoint = activeElement.length
      ? firstElement.offset().left - activeElement.offset().left
      : 0;

    const leftCorner = activeElement.length
      ? $(window).width() / 2 - activeElement.width() / 2
      : 0;

    console.log(`${container}`);  

    if(!isDesktop());
      document.querySelector(`${container}`).scroll(-1 * scrollPoint - leftCorner + 30, 0);
  });
});

function isDesktop() {
  return window.matchMedia('(min-width: 769px)').matches;
}

/*
$scrollTo = $(element).find('li:first').offset().left - $(element).find('li.active').offset().left;

$leftCorner = $(window).width() / 2 - $(element).find('li.active').width() / 2;
element.scrollTo( -1 * $scrollTo - $leftCorner + 30, 0);
*/
